/*
 * @Author: yexiu
 * @Date: 2024-12-09 10:28:06
 * @LastEditors: monai
 * @LastEditTime: 2025-07-23 14:53:20
 */
import { App, reactive } from 'vue';
import HttpClient from './tools/getHttpClient';
import tsxImage from './components/image';
import getCountryCode from './tools/getCountryCode';
import getLangText from './tools/getLangText';
import getRule from './tools/getRule';
import mixin_index from './mixin/mixinIndex';
import fnGetInjectInfo from './tools/fnGetInjectInfo';

export default {
    globalMixin(app: App, parameter){
        mixin_index(app, parameter);
    },
    globalProvide(app: App, {reactText, fnLazyRule, countryCode, activityId, reactActivityInfo, reactDomain}: DevelopToolShare.InitParams){
        // TEXT 文案
        app.provide('TOOL_TEXT', reactText);
        // 规则页
        app.provide('TOOL_RULE', fnLazyRule);
        // 活动信息
        app.provide('TOOL_activityInfo', reactActivityInfo);
        // 域名信息
        app.provide('TOOL_DOMAIN', reactDomain);
        // 当前 countryCode
        app.provide('TOOL_countryCode', countryCode);
        // 活动 ID
        app.provide('TOOL_activityId', activityId);
    },
    globalComponent(app: App, parameter: DevelopToolShare.InitParams){
        app.component('uiImg', tsxImage(parameter));
    },
    init(app: App, parameter: DevelopToolShare.InstallParams): DevelopToolShare.InitParams{
        // 规则页动态响应数据
        const reactRule = reactive<DevelopToolShare.ReactRule>({});
        // 文案动态响应数据
        const reactText = reactive<DevelopToolShare.ReactText>([]);
        // 活动相关信息
        const reactActivityInfo = reactive<DevelopToolShare.ReactActivityInfo>({isEnd: false});
        // 接口返回得各种业务域名，默认值如下
        const reactDomain = reactive<DevelopToolShare.ReactDomain>({});
        // 国家码、parameter 中包含 countryCode 参数，则返回 countryCode。
        const countryCode = getCountryCode(app, parameter.countryCode);
        // 参数赋值：默认使用 useAjaxText，useAjaxRule 指定国家码
        const paramsAssignment: DevelopToolShare.InstallParams = Object.assign({}, {countryCode, useAjaxText: true, useAjaxRule: true, useAjaxDomain: true}, parameter);
        // 文案以及相关配置信息初始化
        getLangText(app, {...paramsAssignment, reactText, reactActivityInfo, reactDomain});
        // 规则页懒加载、返回规则页加载函数
        const fnLazyRule = getRule(app, {...paramsAssignment, reactRule});

        return {...paramsAssignment, reactRule, reactText, reactActivityInfo, reactDomain, fnLazyRule};
    },
    install(app: App, parameter: DevelopToolShare.InstallParams){
        // 初始化之后的参数
        const initParameter = this.init(app, parameter);
        // 全局注入
        this.globalProvide(app, initParameter);
        // 全局组件
        this.globalComponent(app, initParameter);
        // 全局混合
        this.globalMixin(app, initParameter)
    }
}

export {
    fnGetInjectInfo,
};